import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { FieldName } from '../Types/Intyg.enums';
import { RefSetter } from '../Utils/RefSetter';
import { MAX_LENGTH_NUM } from '../Services/intyg.validation.service';
import { EpiserverProperty } from 'sos-common/js/utils/episerver.property';

export interface IPersonuppgifterEjRegleratYrkeProps {}
export interface IPersonuppgifterEjRegleratYrkeState extends FormSectionBaseState {}

export default class PersonuppgifterEjRegleratYrke extends FormSectionBase<
  IPersonuppgifterEjRegleratYrkeProps,
  IPersonuppgifterEjRegleratYrkeState
> {
  constructor(props: IPersonuppgifterEjRegleratYrkeProps) {
    super(props);

    this.fieldRefs.set(FieldName.Epost, React.createRef<TextInput>());
    this.fieldRefs.set(FieldName.Bekraftaepost, React.createRef<TextInput>());

    this.fieldRefs.set(FieldName.Personnummer, React.createRef<TextInput>());
    this.fieldRefs.set(FieldName.Fornamnn, React.createRef<TextInput>());
    this.fieldRefs.set(FieldName.Efternamn, React.createRef<TextInput>());
    this.fieldRefs.set(FieldName.Gatuadress, React.createRef<TextInput>());
    this.fieldRefs.set(FieldName.Postnummer, React.createRef<TextInput>());
    this.fieldRefs.set(FieldName.Postort, React.createRef<TextInput>());

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  webFormLayout = () => {
    const { Translate, model, formLanguage } = this.context;

    return (
      <RefSetter fieldRefs={this.fieldRefs}>
        <div className="row m-b-2">
          <div className="col-sm-6">
            <TextInput
              ref={this.fieldRefs.get(FieldName.Personnummer) as any}
              label={Translate('pnrorbirthday') + ' (obligatoriskt)'}
              fieldName={FieldName.Personnummer}
              isRequired={true}
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Personnummer)}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="off"
            />
          </div>
        </div>
        <div className="row m-b-2">
          <div className={`col-sm-6`}>
            <TextInput
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Fornamnn)}
              label={Translate('fornamn') + ' (obligatoriskt)'}
              isRequired={true}
              fieldName={FieldName.Fornamnn}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="given-name"
            />
          </div>
          <div className={`col-sm-6`}>
            <TextInput
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Efternamn)}
              label={Translate('efternamn') + ' (obligatoriskt)'}
              isRequired={true}
              fieldName={FieldName.Efternamn}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="family-name"
            />
          </div>
        </div>
        <div className="row m-b-2">
          <div className="col-sm-6">
            <TextInput
              label={Translate('gatuadress') + ' (obligatoriskt)'}
              fieldName={FieldName.Gatuadress}
              isRequired={true}
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Gatuadress)}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="address-line1"
            />
          </div>
        </div>
        <div className="row m-b-2">
          <div className={`col-sm-6`}>
            <TextInput
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Postnummer)}
              label={Translate('postnummer') + ' (obligatoriskt)'}
              isRequired={true}
              fieldName={FieldName.Postnummer}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="postal-code"
            />
          </div>
          <div className={`col-sm-6`}>
            <TextInput
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Postort)}
              label={Translate('postort') + ' (obligatoriskt)'}
              isRequired={true}
              fieldName={FieldName.Postort}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="address-level2"
            />
          </div>
        </div>
        <div className="row m-b-2">
          <div className={`col-sm-6`}>
            <TextInput
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Epost)}
              isRequired={true}
              label={Translate('epost') + ' (obligatoriskt)'}
              fieldName={FieldName.Epost}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="email"
            />
          </div>
          <div className={`col-sm-6`}>
            <TextInput
              onChange={this.onChangeField}
              referenceValue={model.epost}
              errorMessage={this.getErrorMessage(FieldName.Bekraftaepost)}
              isRequired={true}
              label={Translate('epostbekraftelse') + ' (obligatoriskt)'}
              fieldName={FieldName.Bekraftaepost}
              disablePaste={true}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="email"
            />
          </div>
        </div>
      </RefSetter>
    );
  };

  public render() {
    const { isInEditMode } = this.context;

    return (
      <section className="m-b-4">
        <EpiserverProperty propertyName="HeadingPersonuppgifter" isInEditMode={isInEditMode}>
          <h2>{this.findProperty('HeadingPersonuppgifter', 'personuppgifter')}</h2>
        </EpiserverProperty>
        {this.webFormLayout()}
      </section>
    );
  }
}
